// ヘッダーの高さを更新する関数（他でも使いたい）
export const updateHeaderHeight = () => {
  const header = document.getElementById("header");
  if (header) {
    const height = header.offsetHeight;
    document.documentElement.style.setProperty("--header-height", `${height}px`);
  }
};

// 初期化時のセットアップ関数（イベント登録のみ）
export const initSetHeaderHeight = () => {
  window.addEventListener("load", updateHeaderHeight);
  window.addEventListener("resize", updateHeaderHeight);
};
